import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PropTypes from "prop-types";

import Misc from "../../../misc/misc";
import MaterialsWizardFooterStepThumbnail from "./materialsWizardFooterStepThumbnail";
import {getFeatureGroupFromWizardGroup} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {switchToWizardItem, useChangeWizardStepRoute} from "./useChangeWizardStepRoute";
import useExpandCollapseLogic from "../materialsCommon/useExpandCollapseLogic";
import MaterialsWizardDoneCheckMark, {showWizardStepDoneCheckMark} from "./materialsWizardDoneCheckMark";
import {wizardGroupInterface, wizardItemInterface} from "../../../interfaces/wizardItemInterface";
import {toggleSelectionFeatureInfo} from "../../../actions/actionFunctions";


const MaterialsWizardFooterStep = (props) => {

  const {wizardSelectedValue, wizardActiveStep, stepIndex, stepGroups, stepDisabled, wizardItem, cartItems,
    isShoppingCart, selectionFeatureInfo, toggleSelectionFeatureInfo, activeQuoteIndex} = props;

  const {changeWizardStepRoute} = useChangeWizardStepRoute(wizardItem);
  const {expanded, collapsing} = useExpandCollapseLogic(stepIndex, wizardActiveStep);

  let wizardGroup = stepGroups[0];
  if (wizardSelectedValue && wizardSelectedValue.wizardGroup && stepGroups.some(stepGroup => stepGroup.id === wizardSelectedValue.wizardGroup.id)) {
    wizardGroup = wizardSelectedValue.wizardGroup
  }

  const stepButtonClick = async () => {

    if (stepDisabled) {
      return false
    }
    if (selectionFeatureInfo) {
      toggleSelectionFeatureInfo(null);
    }
    if (isShoppingCart) {
      await switchToWizardItem(wizardItem, stepIndex, activeQuoteIndex, wizardGroup ? wizardGroup.id : null);
      return
    }
    // expandRing();
    changeWizardStepRoute(stepIndex, wizardItem);
  }

  let stepName = wizardGroup
    ? wizardGroup.title || wizardGroup.customDisplayName || wizardGroup.productCartTitle || wizardGroup.groupName
    : "";
  if (stepName === "Vanitie") {
    stepName = "Vanity"
  }

  const featureGroup = wizardGroup ? getFeatureGroupFromWizardGroup(wizardGroup) : null;
  const isActive = wizardActiveStep === stepIndex && !isShoppingCart;

  const showDoneCheckMark = showWizardStepDoneCheckMark(wizardSelectedValue, featureGroup, cartItems, activeQuoteIndex);

  return (
    // <button className={"selection-footer-list__item selection-footer-list__item--wizard selection-footer-list__item--"+""
    //   + (isActive ? " selection-footer-list__item--active" : "") + (isVisible ? " lw-step--visible" : "")}
    <button className={"selection-footer-list__item " + (isActive ? " selection-footer-list__item--active" : "")
      + (stepDisabled ? " selection-footer-list__item--disabled" : "")
      + (featureGroup ? " selection-footer-list__item--" + featureGroup.partId : "")}
            data-step={stepIndex}
            // style={style}
            onClick={stepButtonClick}>
      {isShoppingCart ? null : (
        <div className={"white-ring" + (expanded || collapsing ? " white-ring--expanded" : "")}>
          <div className={"white-ring-expand"}>
            <div className="white-ring-expand__dashes"/>
          </div>
        </div>
      )}
      <div className={"selection-footer-list__item-inner" + (isActive && !expanded ? " scaled" : "")}>
        <MaterialsWizardFooterStepThumbnail wizardGroup={wizardGroup}
                                            featureGroup={featureGroup}
                                            wizardSelectedValue={wizardSelectedValue}/>
      </div>
      {showDoneCheckMark ? <MaterialsWizardDoneCheckMark /> : null}
      <span className="selection-footer-list__item-text">{Misc.textSubStringEllipsis(stepName, 32)}</span>
    </button>
  )

};

MaterialsWizardFooterStep.propTypes = {
  wizardItem: PropTypes.shape(wizardItemInterface),
  stepGroups: PropTypes.arrayOf(PropTypes.shape(wizardGroupInterface)),
}

const mapStateToProps = (store) => {
  const {wizardActiveStep, wizardSelectedValues} = store.wizardState;
  const {filterGroups} = store.filterState;
  const {isMobile, activeTheme} = store.serverState;
  const {selectionFeatureInfo} = store.selectionState;
  const {cartItems} = store.cartState;
  const {activeQuoteIndex} = store.quotesState;

  return {
    cartItems,
    wizardActiveStep,
    // wizardSelectedValues,
    allFilterGroups: filterGroups,
    wizardSelectedValues,
    isMobile,
    activeTheme,
    selectionFeatureInfo,
    activeQuoteIndex,
  };
};

const mapDispatchToProps = {
  toggleSelectionFeatureInfo
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MaterialsWizardFooterStep)
)
